import { AppBar as BaseAppBar, AppBarProps } from 'react-admin';
import { Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  logo: {
    width: 170
  },
  title: {
    flex: 1,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },
  spacer: {
    flex: 1
  }
});

export default function AppBar(props: AppBarProps) {
  const classes = useStyles(props);
  return (
    <BaseAppBar color="primary" {...props}>
      <Typography variant="h6" color="inherit" className={classes.title}>
        Brasal Refrigerantes
      </Typography>
      <span className={classes.spacer} />
    </BaseAppBar>
  );
}
